export enum ErrorCode {
  INVALID_UNLOCK_TOKEN = 'INVALID_UNLOCK_TOKEN',
  FORBIDDEN = 'FORBIDDEN',
  UNAUTHORIZED = 'UNAUTHORIZED',
  LOGIN_PREREQUISITE = 'LOGIN_PREREQUISITE', // this code is specific to the /login-info end point
  CONSENT_PREREQUISITE = 'CONSENT_PREREQUISITE', // this code is specific to the /consentInfo end point
  CONSENT_EXPIRED = 'CONSENT_EXPIRED', // the authorize request behind the consent screen is no longer valid
  SSO_LOGIN_EXPIRED = 'SSO_LOGIN_EXPIRED', // the OIDC correlation cookie was gone when the SSO callback arrived
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR', // the reason phrase the server's error handlers redirect with
}

/**
 * The heading over whatever IdentityServer recorded for a failed authorize request. The server
 * answers with facts only, so the wording lives here with the rest of this screen's copy.
 */
export const signInFailedTitle = "Your sign-in couldn't be completed";

export const errorCodeMap = {
  [ErrorCode.INVALID_UNLOCK_TOKEN]: {
    title: 'Your unlock account link has expired',
    message:
      'You can generate a new link by using the forgot password option or by contacting us directly.',
  },
  [ErrorCode.FORBIDDEN]: {
    title: 'Access denied',
    message:
      'You do not have permission to perform this action. Access levels for your user account may not be set correctly.',
  },
  [ErrorCode.UNAUTHORIZED]: {
    title: 'Unauthorized access',
    message: 'You do not have permission to perform this action.',
  },
  [ErrorCode.LOGIN_PREREQUISITE]: {
    message:
      'There was a problem loading your account information. Please check that the URL entered is correct and try again. If the problem persists please contact your system administrator.',
  },
  [ErrorCode.CONSENT_PREREQUISITE]: {
    title: 'We could not load this authorization request',
    message:
      'Nothing was authorized. Go back to the application and try connecting again. If the problem persists please contact your system administrator.',
  },
  [ErrorCode.SSO_LOGIN_EXPIRED]: {
    title: 'Your sign-in took too long',
    message:
      'The sign-in attempt expired before it completed. Please return to where you started and sign in again.',
  },
  [ErrorCode.INTERNAL_SERVER_ERROR]: {
    title: 'Something went wrong',
    message:
      'Sorry, an unexpected error occurred while trying to process your request. Please try again.',
  },
  [ErrorCode.CONSENT_EXPIRED]: {
    title: 'This authorization request has expired',
    message:
      'Nothing was authorized. A new request can only come from the application that sent you here, so go back to it and start connecting again. The button below only returns you to your CMG account.',
  },
};
